export const EMAIL = "hello@ohprice.com";
export const DEFAULT_CURRENCY = "USD";
export const PHONE = "+44 7521 050210";
export const PHONE_HREF = "tel:+447521050210";
export const CITY = "London";
export const OPENING_HOURS = "Monday - Friday: 9:00 AM - 5:00 PM";
export const ADDRESS_FULL = "407, Harlington Road Uxbridge Middlesex UB8 3JG";
export const ADDRESS_1 = "407, Harlington Road";
export const ADDRESS_2 = "Uxbridge Middlesex UB8 3JG";
